import { notEmpty } from '../../utils/validator'
export default {
  className: 'storageInfo',
  tableSize: 'small',
  fields: [
    {
      name: 'name',
      validators: [
        notEmpty()
      ]
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.types = 'storage'
    },
    beforeSave ({ data }) {
      data.types = 'storage'
    }
  },
  action: {
    create: {
      icon: ''
    },
    export: {
      icon: ''
    }
  }
}
